import {
  DO_PAYMENT_POST_SUCCESS,
  DO_PAYMENT_SIGN_VOID_SUCCESS,
  DO_PAYMENT_SIGN_REFUND_SUCCESS,
  DO_PAYMENT_POST_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  recordListSing: "",
  recordListSignRefund: "",
  error: {},
}

const doPayment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DO_PAYMENT_POST_SUCCESS:
      return {
        ...state,
        recordList: [...state.recordList, action.payload],
      }
    case DO_PAYMENT_SIGN_VOID_SUCCESS:
      return {
        ...state,
        recordListSing: action.payload,
      }
    case DO_PAYMENT_SIGN_REFUND_SUCCESS:
      return {
        ...state,
        recordListSignRefund: action.payload,
      }
    case DO_PAYMENT_POST_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
export default doPayment